export default __webpack_public_path__ + "static/media/404.73013e8c.svg";